<template>
  <span v-if="displayedLabel" class="status-badge" :style="{ backgroundColor: backgroundColor }">{{ displayedLabel }}</span>
</template>

<script>
import {BUSINESS_STATUS_ENUM} from "@/models/businessStatusEnum";
import {getStatusBackgroundColor} from "@/components/tables/commons/statusColors";

export default {
  name: 'StatusBadge',
  props: {
    status: {type: String, default: undefined},
    label: {type: String, default: undefined},
    // Enum dans laquelle chercher le libellé du status (ex: CREDIT_NOTE_STATUS_ENUM pour les avoirs)
    statusEnum: {type: Object, default: () => BUSINESS_STATUS_ENUM},
  },
  computed: {
    displayedLabel() {
      if (this.label) return this.label;
      const status = this.statusEnum[this.status];
      return status ? status.label : '';
    },
    backgroundColor() {
      return getStatusBackgroundColor(this.status);
    },
  },
};
</script>

<style lang="stylus" scoped>
.status-badge
  display inline-block
  padding 1px 8px
  border-radius 20px
  font-size 0.85em
  font-weight 600
  line-height 1.5
  white-space nowrap
  color inherit
</style>